export default class GoogleTagManagerService {
  static setTag(tag) {
    if (window.dataLayer !== undefined) {
      window.dataLayer.push({
        'event': 'ga_event',
        ...tag
      });
    }
  }
}
